import React from "react";
import {interpolate, useCurrentFrame} from "remotion";
import {techLaunchData} from "../../../data/techLaunchData";


export const Cover: React.FC = () => {

  const frame = useCurrentFrame();

  const opacity = interpolate(
    frame,
    [0, 30],
    [0, 1],
    {
      extrapolateRight: "clamp",
    }
  );


  const scale = interpolate(
    frame,
    [0, 60],
    [0.8, 1],
    {
      extrapolateRight: "clamp",
    }
  );


  return (
    <div
      style={{
        flex: 1,
        backgroundColor: "#050505",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        color: "white",
        opacity,
        transform: `scale(${scale})`,
      }}
    >

      <h1
        style={{
          fontSize: 90,
          fontWeight: 700,
          margin: 0,
        }}
      >
        {techLaunchData.title}
      </h1>


      <p
        style={{
          fontSize: 40,
          marginTop: 40,
          opacity: 0.8,
        }}
      >
        {techLaunchData.subtitle}
      </p>


    </div>
  );
};
